import React, { FunctionComponent, useContext } from "react";
import { RunnerContext } from "../../context/RunnerContext";
import { AbsolvedRun } from "./AbsolvedRun";
import { Separator } from "../../components/ui/separator";
import { ScrollArea } from "../../components/ui/scroll-area";

interface Props {}

export const AbsolvedRuns: FunctionComponent<Props> = () => {
  const { runs, setRuns } = useContext(RunnerContext);

  const deleteCallback = (runId: string) => {
    setRuns(runs.filter((run) => run.runId != runId));
  };

  return (
    <div className={"w-full h-full flex flex-col p-3 gap-4"}>
      <p className={"text-2xl dark:text-white"}>Deine Runs</p>
      <ScrollArea className={" h-96 overflow-y-auto"}>
        {runs.map((run, index) => (
          <>
            <AbsolvedRun
              key={run.runId}
              run={run}
              deleteCallback={deleteCallback}
            />
            {index !== runs.length - 1 && <Separator className={"mb-1"} />}
          </>
        ))}
      </ScrollArea>
    </div>
  );
};
